import { createSelector } from '@reduxjs/toolkit';
import { selectCmsFromBootstrap, selectConfigFromBootstrap } from 'store/slice/bootstrap';
import { BootstrapConfig, CmsValue } from 'core/type/BootstrapConfig.types';
import { PointBreakupProps } from 'gql/service/graph/activityService';

interface OwnProps {
    pointBreakup: PointBreakupProps;
    isMobileScreen?: boolean;
    isOptionDisabled?: boolean;
    showPointsBadge?: boolean;
}

interface StateProps {
    cms: CmsValue;
    config: BootstrapConfig;
}

export type PriceWithBadgePointsProps = OwnProps & StateProps;

export const mapStateToProps = createSelector(selectCmsFromBootstrap, selectConfigFromBootstrap, (cms, config): StateProps => {
    return { cms, config };
});
